import { Outlet } from "react-router-dom"
import { Header } from "./Header"
import { NoDivisionSelected } from "./NoDivisionSelected"
import { useUIStore } from "../../stores"

export function DashboardLayout() {
  const selectedDivision = useUIStore((s) => s.selectedDivision)

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-muted">
      <Header />
      <main className="flex-1 overflow-auto bg-muted relative pb-24">
        {selectedDivision ? <Outlet /> : <NoDivisionSelected />}
      </main>
    </div>
  )
}
